module.exports = __webpack_public_path__ + "img/72WestVineSt_Small.0f411043.png";